export const categories = [
  { key: "materialRates", title: "Materials" },
  { key: "equipmentRates", title: "Equipment" },
  { key: "laborRates", title: "Labor" },
  { key: "openInspectRates", title: "Open & Inspect" },
  { key: "oneTimeCharge", title: "One Time Flat Charge" },
];

export const sections = [
  { key: "materialCharges", title: "Material Charges" },
  { key: "equipmentCharges", title: "Equipment Charges" },
  { key: "laborCharges", title: "Labor Charges" },
  { key: "openInspectCharges", title: "Open & Inspect Charges" },
  { key: "oneTimeCharges", title: "One Time Flat Charges" },
];
